import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { submitPatient, loadForm, setActive, resetPatientError } from '../../actions/patient';
import { addToken, deleteToken } from '../../actions/token';
import PatientForm from './PatientForm';
import TitlePage from '../../containers/Header/TitlePage';
import { editPatientDetails, formatPatientDetails, hasKeys } from '../simpleFunctions';
import PatientHomeNav from '../PatientHome/PatientHomeNav';
import { Container, Row, Col } from 'reactstrap';

/*
* Purpose of class: This is the container for the redux-form for the patient resource editing form
*/
class PatientEdit extends Component {

    state = {
      // Use: to set to false once the loadForm action has been called
      fetched: false,
      // Use: used to check if the form has changed since the last reload/last submission
      changed: false,
    };

    // Use: triggered when the save/submit button is clicked
    handleSave = () => {
      // Use: reset changed as the form has been saved
      this.setState({
        changed: false,
      });


      // Use: for the default values especially if this is a new patient being created
      let responseObject = editPatientDetails('', this.props.formValues.values, true);

      if (hasKeys(this.props, 'patient.patient.resource')) {
        /*
                * Reasoning for the parameter values:
                * - this.props.patient.patient.resource: for when the patient resource already exists ...
                *   and the form values can be directly mapped to the patient resource object keys
                */
        // Use: if the patient resource already exists, just edit that resource object in state
        responseObject = editPatientDetails(this.props.patient.patient.resource, this.props.formValues.values, false);
      }

      // call to backend to submit Patient Resource
      this.props.submitPatient(responseObject);
      // if the patient resource is for a new patient, now the user's changed will edit the created patient resource object
      this.props.setActive(responseObject);
      // reset the response error object
      this.props.resetPatientError();
    }

    handleChange() {
      // Use: make it known the the form fields are now "dirty" ...
      //      or have been changed since the last save/reload of the page
      this.setState({
        changed: true,
      });
    }

    componentDidMount() {
      // Use: check if clinician state object is null ...
      //      occurs when the user is not logged in and they try this url path

      if (this.props.clinician.clinician === null) {
        this.props.history.push('/');
      }

      // Use: reset request errors upon reloading
      this.props.resetPatientError();
    }

    render() {
      // Use: If the patient resource object is not retrieved, return to landing page
      if (this.props.patient.error === '') {
        this.props.history.push('/');
      }

      // Use: when user is redirected to this page, check if it's for a new patient creation or editing an existing resource
      // *    This condition will only execute once in every reload due to the state "fetched" being set to "true" after the if condition is true
      // **   I realised while I was cleaning up the code, that these one time checks should be put in a componentDidUpdate, please do it if this comment is still here

      if (!(this.props.location.new) &&
            hasKeys(this.props, 'patient.patient') &&
            this.state.fetched === false) {
        // Use: check if patient resource exists
        if (hasKeys(this.props, 'patient.patient.resource')) {
          /*
                * Reasoning for the parameter values:
                * - this.props.patient.patient.resource: Extract and map the values into the form object to repopulate the form fields with existing data
                */
          // Use: return a form object mapped from the patient resource
          const tempObj = formatPatientDetails(this.props.patient.patient.resource);

          // load this form into its state object
          this.props.loadForm(tempObj);

          // Use: make sure this if condition only executes once every reload
          this.setState({ fetched: true });
        } else {
          // Use: if patient is a new one, then just say that that the form as been loaded
          this.setState({ fetched: true });
        }
      }

      return (
        <div>
          <div><TitlePage /></div>
          <PatientHomeNav history={this.props.history} />

          {this.props.location.new ?
            <div>
              <Container fluid>
                <Row>
                  <Col>
                    <p className="display-4" align="center">
                        Add New Patient
                    </p>
                  </Col>
                </Row>
              </Container>
              <PatientForm
                handleSave={() => this.handleSave()}
                handleChange={() => this.handleChange()}
                changed={this.state.changed}
                noError={this.props.patient.error}
                hasPatient={hasKeys(this.props, 'patient.patient.resource.id')}
              />
            </div>
            :
            <div>
              <Container fluid>
                <Row>
                  <Col>
                    <p className="display-4" align="center">
                        Edit Patient
                    </p>
                  </Col>
                </Row>
              </Container>
              <PatientForm
                handleSave={() => this.handleSave()}
                handleChange={() => this.handleChange()}
                changed={this.state.changed}
                noError={this.props.patient.error}
                initialValues={this.props.patient.formPatient}
                hasPatient={hasKeys(this.props, 'patient.patient.resource.id')}
              />
            </div>
          }
        </div>
      );
    }
}

const mapStateToProps = state => ({
  formValues: state.form.patientForm,
  patient: state.patient,
  token: state.token.tokenList,
  clinician: state.clinician,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      submitPatient,
      loadForm,
      addToken,
      setActive,
      deleteToken,
      resetPatientError,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PatientEdit);



// WEBPACK FOOTER //
// ./src/components/PatientDetails/PatientEdit.js